export const COPILOT_DISCLAIMER = "KI-Hinweis · ENTWURF · keine Freigabe, keine Garantie — fachlich/menschlich prüfen.";
/**
 * Fachliche Anreicherung je Checklisten-Code: Risiko-Erklärung + nächster Schritt.
 * Nur für „nicht ok"-Zustände relevant (ok/info-neutral erzeugen keinen Hinweis,
 * außer sie sind planungsrelevant).
 */
const ENRICH = {
    geometry_missing: {
        detail: "Ohne geschlossene Dachfläche kann nichts geplant werden (keine Fläche, kein Ertrag, keine Belegung).",
        nextStep: "Dachfläche auf der Karte zeichnen (Polygon/Rechteck).",
    },
    geometry_incomplete: {
        detail: "Eine Fläche hat < 3 Eckpunkte oder 0 m² — Fläche, kWp und Belegung sind dadurch unzuverlässig.",
        nextStep: "Unvollständige Dachfläche schließen oder entfernen.",
    },
    edges_missing: {
        detail: "Ohne First/Traufe kennt das System die Dachausrichtung/Neigungsrichtung nicht und kann Randabstände nicht korrekt setzen.",
        nextStep: "First- und Trauflinie als Dachkanten auf der Karte zeichnen.",
    },
    tilt_extreme: {
        detail: "Ungewöhnliche Dachneigung (< 5° oder > 65°) — Ertrag/Statik bitte prüfen, evtl. Eingabefehler.",
        nextStep: "Dachneigung der betroffenen Fläche kontrollieren.",
    },
    azimuth_north: {
        detail: "Nordseitige Ausrichtung mindert den Ertrag deutlich — Wirtschaftlichkeit kritisch prüfen.",
        nextStep: "Ausrichtung prüfen; ggf. nur süd-/ost-/westseitige Flächen belegen.",
    },
    obstacles_no_height: {
        detail: "Hindernisse ohne Höhe machen die Verschattungsberechnung wertlos (Schattenlänge unbekannt).",
        nextStep: "Höhe für jedes Hindernis (Kamin/Gaube/SAT …) erfassen.",
    },
    modules_none: {
        detail: "Es sind keine Module platzierbar — Fläche zu klein, Abstände zu groß oder zu viele Sperrflächen.",
        nextStep: "Fläche/Randabstände/Sperrflächen prüfen, dann Belegung erneut rechnen.",
    },
    string_fail: {
        detail: "Die Strangspannung liegt außerhalb des Wechselrichter-Fensters — Sicherheits- und Haftungsrisiko.",
        nextStep: "Module pro String oder Wechselrichter-Auslegung korrigieren.",
    },
    yield_missing: {
        detail: "Ohne Ertragswert (PVGIS/Simulation) sind Wirtschaftlichkeit und Konzept nicht belastbar.",
        nextStep: "PVGIS-/Ertragssimulation für diesen Standort ausführen.",
    },
};
const SEV_RANK = { critical: 3, warning: 2, info: 1 };
/** Planungs-Reihenfolge für die Auswahl des EINEN nächsten Schritts. */
const STEP_ORDER = [
    "geometry_missing",
    "geometry_incomplete",
    "edges_missing",
    "obstacles_no_height",
    "modules_none",
    "string_fail",
    "yield_missing",
    "azimuth_north",
    "tilt_extreme",
];
function hintFromCheck(c) {
    if (c.state === "ok")
        return null;
    const enrich = ENRICH[c.code];
    if (!enrich)
        return null; // neutrale info-Punkte (z. B. keepouts_info) ⇒ kein Hinweis
    const severity = c.state === "critical" ? "critical" : c.state === "warning" ? "warning" : "info";
    return { code: c.code, severity, title: c.title, detail: enrich.detail, nextStep: enrich.nextStep };
}
/**
 * Leitet aus dem Prüfampel-Ergebnis eine deterministische Copilot-Beratung ab.
 * Reiner, testbarer Mapper — keine Seiteneffekte, kein LLM, keine PII.
 */
export function buildRoofCopilotAdvice(checklist) {
    const hints = checklist.checks
        .map(hintFromCheck)
        .filter((h) => h !== null)
        .sort((a, b) => SEV_RANK[b.severity] - SEV_RANK[a.severity]);
    const readiness = checklist.verdict === "critical" ? "not_ready" : hints.length > 0 ? "caution" : "ready";
    // Den EINEN nächsten Schritt nach Planungsreihenfolge wählen (erste offene Lücke).
    let nextStep = null;
    for (const code of STEP_ORDER) {
        const h = hints.find((x) => x.code === code);
        if (h) {
            nextStep = h.nextStep;
            break;
        }
    }
    if (nextStep === null && hints.length > 0)
        nextStep = hints[0].nextStep;
    const open = hints.length;
    const headline = readiness === "ready"
        ? "Dachfläche ist für die Modulbelegung vorbereitet — menschliche Prüfung weiterhin nötig."
        : readiness === "not_ready"
            ? `${open} offene${open === 1 ? "r" : ""} Punkt${open === 1 ? "" : "e"} — Dachfläche noch nicht bereit für die Belegung.`
            : `${open} Hinweis${open === 1 ? "" : "e"} vor der Modulbelegung beachten.`;
    return {
        headline,
        readiness,
        hints,
        nextStep,
        disclaimer: COPILOT_DISCLAIMER,
        requiresHumanReview: true,
        canApprove: false,
    };
}
//# sourceMappingURL=roof-copilot.js.map